export default {
    toggleAllUsers: true
}